import React, { useState, useEffect, useContext } from 'react'
import { Link } from "react-router-dom"
import {
  useLocation
} from 'react-router-dom'

import { StateController } from './../../App'

import VerticalCenter from '../VerticalCenter/VerticalCenter'
import Container from '../Container/Container'
import Icon from '../../components/atoms/Icon'
//import CounterBanner from '../../components/atoms/CounterBanner'
import Profile from '../../components/atoms/Profile'
import { sendDataLayer } from '../../utils/functions'

function Header({
  headerType,
  // logo,
  // logo_mb,
  logo_mc,
  logo_mc_mb,
  items,
  submenu,
  loggedIn,
  // logOutAction
}) {
  const { context } = useContext(StateController)
  const location = useLocation()
  const [showOthers, setShowOthers] = useState(false)
  const [hasChildren, setHasChildren] = useState(false)
  const [logito, setLogito] = useState("/assets/images/Logos.svg")
  const [logitoClass, setLogitoClass] = useState("")

  const togglerMenu = (e, page) => {
    setShowOthers(!showOthers)
    sendDataLayer({ datalayer: { event: "menu", text: (e.target.textContent === '') ? 'Mas' : e.target.textContent, link: page }, repeat: true })

  }

  // const toogleSumMenu = (e) => {
  //   setShowMenu(!showMenu)
  //   sendDataLayer({datalayer: {event: "menu",text: e.target.textContent,link: window.location.href},repeat: true})

  // }

  const addDataLayer = (e, page) => {
    sendDataLayer({ datalayer: { event: "menu", text: (e.target.textContent === '') ? 'Premios' : e.target.textContent, link: page }, repeat: true })

  }

  useEffect(() => {
    const child = items.find((item) => item.sublevel)

    if (child) {
      setHasChildren(child)
    }
  }, [items])

  useEffect(() => {

    window.addEventListener('click', ({ target }) => {
      const window = target.closest('.mc-header-container__nav--extra')
      const button = target.closest('.mc-header-container__nav--button')

      if (window === null && button === null) setShowOthers(false)
    })
  }, [])

  useEffect(() => {
    if (context?.user?.segment) {
      let market = context.user.segment.toLowerCase();
      if (context.user.segment === 'exito') {
        setLogito("/assets/images/TarjetaExito.svg")
      }
      else if (market === 'carulla') {
        setLogito("/assets/images/TarjetaCarulla.svg")
      }

      setLogitoClass("market-logo")
    }
  })

  // const closeSession = (e) => {
  //   logOutAction()
  //   setShowOthers(false)
  //   sendDataLayer({datalayer: {event: "menu",text: e.target.textContent,link: window.location.href},repeat: true})

  // }

  return (
    <div
      className={`
      mc-header-container mc-header-container-type-${headerType} 
      mc-header-container-page-${location.pathname.replace('/', '') !== '' ? location.pathname.replace('/', '') ? location.pathname.replace('/', '') : 'login' : 'login'}`
      }>
      <div className='mc-header-container__menu'>

        <a className={`mc-header-container__logo--desktop t1 ${loggedIn && 'log'}`} href={loggedIn ? '/progreso' : '/'}>
          <img src={logito} alt="tuya logo" className={logitoClass} />
        </a>
        
        <a className={`mc-header-container__logo--desktop t2 ${loggedIn && 'log'}`} href={loggedIn ? '/progreso' : '/'}>
          <img src={`/assets/images_ty/${logo_mc}`} alt="Logo Mastercard" className='logitoMC' />
        </a>
        <Container fullHeight={true}>
          {/*<CounterBanner 
            endDate="2026-06-15T23:59:00-05:00" 
            onClose={() => console.log('cerrado')} 
          />*/}

          <a className={`mc-header-container__logo ${loggedIn && 'logged'}`} href={loggedIn ? '/progreso' : '/'}>
            <img src={logito} alt="Logo Banco" className={`${loggedIn && 'log'} ${logitoClass}`} />
          </a>
          <a className={`mc-header-container__logo t2 ${loggedIn && 'logged'}`} href={loggedIn ? '/progreso' : '/'}>
            <img src={`/assets/images/${logo_mc_mb}`} alt="Logo Mastercard" />
          </a>

          <nav className="mc-header-container__nav">
            {loggedIn
              ? <>
                {/* <div className="mc-header-container__nav--close" onClick={closeSession}>
                  <span>
                    <Icon name='close_session' />
                  </span>
                </div> */}
              </>
              : <ul>

                {items.filter((item) => {
                  if (item?.component?.props?.privatePage || item?.sublevel) {
                    return false
                  } else {
                    return true
                  }
                }).map((item, index) => {
                  return (
                    <li
                      className={`mc-header-container__nav--item item-${item.page} slow_ani ${location.pathname.replace('/', '') === item.page && !showOthers ? 'mc-header-container__nav--item-active' : ''}`}
                      onClick={addDataLayer}
                      key={index}
                    >
                      <Link to={`/${item.page}`}>
                        <VerticalCenter>
                          <span>
                            {item.icon &&
                              <Icon name={item.icon} />
                            }
                            {item.title}
                          </span>
                        </VerticalCenter>
                      </Link>
                    </li>
                  )
                })}
              </ul>
            }

            {hasChildren &&
              <div className={`mc-header-container__nav--extra slow_ani ${showOthers ? 'opened' : ''}`}>
                {hasChildren.children.map((item, index) => {
                  return (
                    <Link to={`/${item.page}`} key={index} onClick={(e) => togglerMenu(e, item?.page)} className={`${item.hide ? 'hide' : ''}`}>
                      <span>
                        {item.icon &&
                          <Icon name={item.icon} />
                        }
                        {item.title}
                      </span>
                    </Link>
                  )
                })}
                {/* <div className="mc-header-container__nav--close" onClick={closeSession}>
                  <span>
                    <Icon name='close_session' />
                  </span>
                </div> */}
              </div>
            }
          </nav>
        </Container>
      </div>

      {submenu &&
        <div className={`mc-header-container__submenu ${!loggedIn ? 'not-login' : ''}`}>
          <Container fullHeight={true}>
            <VerticalCenter>
              {submenu.type === 'labels' &&
                <>
                  {submenu.icon && <Icon name={submenu.icon} />}
                  <div dangerouslySetInnerHTML={{ __html: submenu.content }} />
                </>
              }
              {submenu.type === 'nickname' && loggedIn && context?.user?.nickname &&
                <Profile
                  nickname={context.user.nickname}
                  defaultLetter={submenu.default}
                />
              }
            </VerticalCenter>
          </Container>
        </div>
      }
    </div>
  )
}

export default Header